<template>
    <div class="full-wdith" v-loading="loading">
        <div>
            <div class="keyword-part">
                <el-input
                    v-model="keyword"
                    class="w-50 m-2"
                    size="large"
                    :placeholder="`${i18n.tkey('lang_search_text')}...`"
                    :prefix-icon="Search"
                    clearable
                    @change="changeKeyword"
                    style="width: calc(100% - 6em); display: inline-block"
                />
            </div>
        </div>

        <div style="margin-top: 20px">
            <CompanyListBackstage
                :list="dataList"
                @clickBtn="companyActionCallback"
            />
        </div>

        <div>
            <PaginationComponent
                :pageObj="pageObj"
                @goPage="changePage"
            />
        </div>

        <div>
            <!--      移動位置      -->
            <el-dialog
                v-model="openMoveVisible"
                :title="i18n.tkey('lang_modify')"
                :width="myUtil.isMobile() ? '90%' : '800px'"
                align-center
                destroy-on-close
                :close-on-click-modal="false"
                :close-on-press-escape="false"
            >
                <MoveHallPosition
                    :record="editRecord"
                    :type="-1"
                    @save-complete="savePositionCallback"
                />
            </el-dialog>
        </div>

        <div>
            <!--      員工管理      -->
            <el-dialog
                v-model="manageStaffVisible"
                :title="i18n.tkey('lang_staff_manage')"
                :width="myUtil.isMobile() ? '90%' : '800px'"
                align-center
                destroy-on-close
                :close-on-click-modal="false"
                :close-on-press-escape="false"
            >
                <DepartManageBackstage
                    :companycode="editCompanycode"
                />
            </el-dialog>
        </div>

        <div>
            <!--      權限管理      -->
            <el-dialog
                v-model="authEditorVisible"
                :title="i18n.tkey('lang_auth_manage')"
                :width="myUtil.isMobile() ? '90%' : '800px'"
                align-center
                destroy-on-close
                :close-on-click-modal="false"
                :close-on-press-escape="false"
            >
                <CompanyAuthEditor
                    :companycode="editCompanycode"
                />
            </el-dialog>
        </div>
    </div>
</template>

<script setup>

import {inject, getCurrentInstance, ref, toRef, onBeforeMount} from "vue";
import PaginationComponent from "@/components/shopopee/common/paginationComponent.vue";
import CompanyListBackstage from "@/components/shopopee/backstage/company/companyListBackstage.vue";
import {useUserinfo} from "@/stores/userinfo";
import companyApi from "@/request/companyApi";
import {Search} from "@element-plus/icons-vue";
import myUtil from "@/util/util";
import MoveHallPosition from "@/components/shopopee/hall/moveHallPosition.vue";
import DepartManageBackstage from "@/components/shopopee/backstage/depart/departManageBackstage.vue";
import CompanyAuthEditor from "@/components/shopopee/company/auth/companyAuthEditor.vue";
import record15Api from "@/request/record15Api";

const userInfoRef = toRef(useUserinfo())
const i18n = inject("i18n")
const loading = ref(false)

const dataList = ref([])

const pageNum = ref(1)
const pageSize = ref(10)
const pageObj = ref({})
const keyword = ref(null)

const openMoveVisible = ref(false)
const manageStaffVisible = ref(false)
const authEditorVisible = ref(false)
const editRecord = ref(null)
const editCompanycode = ref(null)

function getCompanyList(){
    loading.value = true

    const request = companyApi.getCompany3DDetailByPage
    const params = request.getParams()

    params.companyname = keyword.value
    params.districtcode = userInfoRef.value.companycode
    params.pageNum = pageNum.value
    params.pageSize = pageSize.value

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            const obj = res.detail

            pageObj.value = obj

            dataList.value = obj.list

        }
    })

}

function changeKeyword(){
    pageNum.value = 1

    getCompanyList()
}

function changePage(num){
    pageNum.value = num
    getCompanyList()
}

function savePositionCallback(){
    editRecord.value = null
    openMoveVisible.value = false
    getCompanyList()
}

function updateRecordState(obj, state){
    loading.value = true

    const request = record15Api.updateRecordStats
    const params = request.getParams()

    params.id = obj.id
    params.recordno = state

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_save_success"))
            getCompanyList()
        }else{
            myUtil.alertError(res.msg)
        }

    })

}

function logoffCompanyData(obj){
    const request = companyApi.logoffCompanyData
    const params = request.getParams()

    params.companycode = obj.companycode
    params.token = userInfoRef.value.token

    request.send(params, (res) => {
        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_operate_success"))
            getCompanyList()
        }else{
            myUtil.alertError(res.msg)
        }
    })

}

function logoffCompanyConfirm(obj){
    myUtil.confirmError(i18n.tkey("lang_logoff_company_confirm"), () => {
        myUtil.confirmError(i18n.tkey("lang_logoff_company_confirm_3"), () => {
            logoffCompanyData(obj)
        })
    })
}

function companyActionCallback(name, obj){
    switch (name){
        case "moveShop":
            editRecord.value = obj.additionalrecord15
            openMoveVisible.value = true
            break

        case "disableShop":
            updateRecordState(obj.additionalrecord15, "0")
            break

        case "enableShop":
            updateRecordState(obj.additionalrecord15, "-1")
            break

        case "staffManage":
            editCompanycode.value = obj.companycode
            manageStaffVisible.value = true
            break

        case "editAuth":
            editCompanycode.value = obj.companycode
            authEditorVisible.value = true
            break

        case "logoffCompany":
            logoffCompanyConfirm(obj)
            break
    }
}

onBeforeMount(() => {
    getCompanyList()
})

</script>

<style scoped>
    .full-wdith {
        width: 100%;
    }

    .keyword-part {
        text-align: center;
    }
</style>